module.exports = __webpack_public_path__ + "static/img/cross.0e07287.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cross.png
// module id = 156
// module chunks = 0